//image upload w/ preview
(function(window, $, undefined){

    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Controls = window.JVZoo.Controls || {};

    var tagType = 'jvz-image-upload-ctl';
    var aspectRatioRegEx = new RegExp('^\\s*(\\d+(?:\\.\\d+)?):(\\d+(?:\\.\\d+)?)\\s*$', 'i');

    function AspectRatio(ratioString) {

        var matches = ratioString.match(aspectRatioRegEx);

        if (!matches || matches.length !== 3) {
            throw( "Aspect ratio must be a in the form of 'width by height' such as '16:9' or '8:2.5', '2:1' or '1:1'.");
        }
        this.ratio = matches[0];
        this.run = parseFloat(matches[1]);
        this.rise = parseFloat(matches[2]);

        return this;
    }

    AspectRatio.prototype.getHeightFromWidth = function(width){
        if (!window.JVZoo.Common.IsPositiveInteger(width)) {
            console.error("Failed to calculate expected hight by aspect ratio because width was not a positive number");
            return undefined;
        }
        var rawValue = (width / this.run) * this.rise;
        return Math.round(rawValue);
    };

    function ImageUploadControl(element) {
        if (element === undefined || !element) {
            alert("this.$sourceElement cannot be set");
        }

        //if we weren't passed a jQuery object, convert it to one now
        this.$sourceElement
            = element instanceof $
            ? element
            : $(element);

        this.errors = [];
        var errorPrefix = "Failed to create ImageUploadControl:";
        var error = undefined;

        this.minWidth = parseInt(this.$sourceElement.attr('minWidth'));
        if (!window.JVZoo.Common.IsPositiveInteger(this.minWidth)) {
            error = errorPrefix+" 'minWidth' must be a positive integer.";
            console.error(error+" Error for element: ", window.JVZoo.Common.outerHtml(this.$sourceElement));
            this.errors.push(error);
        }

        this.maxWidth =  parseInt(this.$sourceElement.attr('maxWidth'));
        if (!window.JVZoo.Common.IsPositiveInteger(this.maxWidth)) {
            error = errorPrefix+" 'maxWidth' must be a positive integer.";
            console.error(error+" Error for element: ", window.JVZoo.Common.outerHtml(this.$sourceElement));
            this.errors.push(error);
        }

        if (this.minWidth > this.maxWidth) {
            error = errorPrefix+" 'minWidth' of '"+this.minWidth+"' cannot be greater than 'maxWidth' of '"+this.maxWidth+".'";
            console.error(error+" Error for element: ", window.JVZoo.Common.outerHtml(this.$sourceElement));
            this.errors.push(error);
        }

        try {
            this.aspectRatio = new AspectRatio(this.$sourceElement.attr('aspectRatio'));
            this.minHeight = this.aspectRatio.getHeightFromWidth(this.minWidth);
            this.maxHeight = this.aspectRatio.getHeightFromWidth(this.maxWidth);
        } catch (e) {
            error = errorPrefix+" 'aspectRatio' is invalid. "+e;
            console.error( error+" Error for element: ", window.JVZoo.Common.outerHtml(this.$sourceElement));
            this.errors.push(error);
        }

        this.name = this.$sourceElement.attr('name');
        if (!window.JVZoo.Common.IsString(this.name, {minLength:1})) {
            error = errorPrefix+" 'name' must be a string of at least 1 character.";
            console.error(error+" Error for element: ", window.JVZoo.Common.outerHtml(this.$sourceElement));
            this.errors.push(error);
        }

        //save our original source url so we can restore it if they cancel
        this.sourceUrl = this.$sourceElement.attr('data-source-url') || '';

        //use the file type filter supplied or the default value
        this.acceptedFileTypes = this.$sourceElement.attr('accept');
        if(!this.acceptedFileTypes) {
            this.acceptedFileTypes = "image/png, image/jpeg";
        }

        /*
         * 2018-03-21 Adam Lenda
         * Currently Web Components is not universally supported. Google's polymer will get you close with polyfills,
         * but there is lots of caveats to that as well. Therefore, we use the following script to replace our
         * custom element tag with standard dom elements. Once Web Components is finally adopted by
         * all browsers we should switch to that.
         */
        this.$renderedElement =
            $(
                //ensure we preserve any attributes that were supplied to the jvz-image-upload-ctl tag
                this.$sourceElement.clone(false)[0].outerHTML
                    .replace(window.JVZoo.Controls.FirstTagRegEx(tagType), '$1div$2')
                    .replace(window.JVZoo.Controls.LastTagRegEx(tagType), '$1div$2')
            )
            .attr('class', 'jvz-image-upload-ctl '+(this.$sourceElement.attr('class') || ''));

        if (this.errors.length > 0) {
            window.JVZoo.Controls.ShowErrorsForTag(this.$sourceElement, this.errors);
            return this;
        }

        //setup our placeholder background
        this.$backgroundDiv = $('<div>').addClass('jvz-image-missing-bg').css({"width": this.minWidth, "height": this.minHeight});

        //create the file input to submit with the form
        this.$fileInput = $('<input type="file" class="d-none">')
            .attr('accept', this.acceptedFileTypes)
            .attr('name', 'imageFile')
            .on('change', this.onImageFileChange.bind(this));

        //create the field to track if the original file should be deleted
        this.$removeFileInput = $('<input type="hidden">').attr('name', 'removeExistingFile');

        var $dataRemoveExistingFileAttribute = this.$sourceElement.attr('data-remove-existing-file');
        if ($dataRemoveExistingFileAttribute && $dataRemoveExistingFileAttribute.toLowerCase() === 'true') {
            //if the attribute value was set, such as in a render after a validation failure, retain that setting
            this.$removeFileInput.val('true');
        } else {
            this.$removeFileInput.val('false');
        }
        //create the image tag to display the source image or preview the selected image
        this.$img = $('<img class="jvz-img">')
            // .css('width', this.minWidth)
            // .css('height', this.minHeight)
            .attr('name', 'image')
            .attr('src', this.sourceUrl || '');

        //setup our div to contain the instructions and buttons which will float above the other content
        this.$controlsDiv = $('<div>')
            .addClass('jvz-image-overlay')
            .append(
                $('<p class="jvz-mouse-over-instructions">')
                    .append($('<span class="jvz-aspect-ratio-text">').text(this.aspectRatio.ratio+' Image'))
                    .append($('<span class="jvz-image-min-width-text">').text('Minimum: '+this.minWidth+'x'+this.minHeight))
                    .append($('<span class="jvz-image-max-width-text">').text('Maximum: '+this.maxWidth+'x'+this.maxHeight))
            )
            .append($('<div class="jvz-image-upload-ctl-buttons"></div>')
                .append(
                    $('<a href="javascript:void(0);" class="jvz-btn-select-image">')
                        .append($('<i class="icon">'))
                        .on('click', this.onSelectImageFile.bind(this))
                )
                .append(
                    $('<a href="javascript:void(0);" class="jvz-btn-change-image">')
                        .append($('<i class="icon">'))
                        .on('click', this.onSelectImageFile.bind(this))
                )
                .append(
                    $('<a href="javascript:void(0);" class="jvz-btn-cancel-change">')
                        .append($('<i class="icon">'))
                        .on('click', this.onCancelImageFileChange.bind(this))
                )
                .append(
                    $('<a href="javascript:void(0);" class="jvz-btn-remove-image">')
                        .append($('<i class="icon">'))
                        .on('click', this.onRemoveImage.bind(this))
                )
            );
        /*
         * because we cannot have a style target our plain div tag like we could the jvz-image-upload-ctl, we
         * add the jvz-image-upload-ctl class and then append any classes that were defined on the
         * jvz-image-upload-ctl tag
         */
        this.$renderedElement
            .append(this.$fileInput)
            .append(this.$removeFileInput)
            .append(this.$backgroundDiv)/*.css('width', this.minWidth).css('height', this.minHeight)*/
            .append(this.$img)/*.css('width', this.minWidth).css('height', this.minHeight)*/
            //.append(this.$controlsDiv.css('width', this.minWidth).css('height', this.minHeight))
            .append(this.$controlsDiv)
        ;

        return this;
    }

    ImageUploadControl.prototype = {
        $backgroundDiv: null,
        $controlsDiv: null,
        $fileInput: null,
        $img: null,
        $removeFileInput: null,
        $sourceElement: null,
        acceptedFileTypes: null,
        aspectRatio: null,
        errors: [],
        maxHeight: null,
        maxWidth: null,
        minHeight: null,
        minWidth: null,
        name: null,
        onCancelImageFileChange: null,
        onImageFileChange: null,
        onRemoveImage: null,
        onSelectImageFile: null,
        sourceUrl: null
    };

    ImageUploadControl.prototype.onImageFileChange = function(event) {
        var _this = this;

        if (_this.$fileInput[0].files && _this.$fileInput[0].files[0]) {
            var reader = new FileReader();

            reader.onload = function(e) {
                if (e.target && e.target.result) {
                    _this.$img.attr('src', e.target.result);
                    _this.updateDisplay();
                }
            };

            reader.readAsDataURL(_this.$fileInput[0].files[0]);
        }
    };

    ImageUploadControl.prototype.removeImage = function() {
        var _this = this;
        /*
         * In order to allow the user to re-select the same file, we have to 'reset' the input element by attaching
         * it to a new form and then calling reset on that form, then reattaching where it belongs.
         */
        _this.$fileInput.detach();
        $('<form>').append(_this.$fileInput)[0].reset();
        _this.$fileInput.detach();
        _this.$renderedElement.prepend(_this.$fileInput);
        _this.$removeFileInput.val('true');

        /* 2018-06-01 Adam Lenda
         * This could be a a managed input where files are being sent to AWS automatically, so let's announce that this
         * control is getting reset so other components can clean up if the want to.
         */
        window.JVZoo.Controls.FileInputReset.raise(_this, _this.$fileInput);
    };

    ImageUploadControl.prototype.onRemoveImage = function(event) {
        var _this = this;
        _this.$img.attr('src', null);
        _this.removeImage();
        /*
         * Refresh display styles...
         */
        _this.updateDisplay();
    };

    ImageUploadControl.prototype.onCancelImageFileChange = function(event) {
        var _this = this;
        _this.$img.attr('src', _this.sourceUrl);
        _this.removeImage();
        /*
         * Refresh display styles...
         */
        _this.updateDisplay();
    };

    ImageUploadControl.prototype.onSelectImageFile = function(event) {
        console.debug('ImageUploadControl.prototype.onSelectImageFile called!');
        if (!this.$fileInput){
            return;
        }
        this.$fileInput.click();
        this.updateDisplay();
    };

    ImageUploadControl.prototype.render = function() {
        var _this = this;
        if (_this.errors.length > 0) {
            return;
        }
        _this.$sourceElement.replaceWith(_this.$renderedElement);
        window.JVZoo.Controls.SetFullyQualifiedFieldNames(_this.$renderedElement);
        _this.updateDisplay();
    };

    ImageUploadControl.prototype.updateDisplay = function() {
        var _this = this;
        if (_this.errors.length > 0) {
            //no work to do
            return;
        }
        if(_this.$img.attr('src')) {
            _this.$renderedElement.addClass('jvz-image-set');
        } else {
            _this.$renderedElement.removeClass('jvz-image-set');
        }

        if(_this.$img.attr('src') !== _this.sourceUrl) {
            _this.$renderedElement.addClass('jvz-image-changed');
            //if the sourceUrl was not empty, set the field to indicate that we are going to need to remove that image
            if (window.JVZoo.Common.IsString(_this.sourceUrl, {minLength:1})) {
                _this.$removeFileInput.val('true');
            }
        } else {
            _this.$renderedElement.removeClass('jvz-image-changed');
            _this.$removeFileInput.val('false');
        }
    };

    window.JVZoo.Controls.ImageUploadControl = window.JVZoo.Controls.ImageUploadControl || ImageUploadControl;

    var applyBindings = function($root) {
        $root.find(tagType).each(function(index, value){
            var imageUploadControl = new window.JVZoo.Controls.ImageUploadControl($(value));
            imageUploadControl.render();
        });
    };

    $(document).ready(function(){
        applyBindings($(document));
        window.JVZoo.Controls.NewControlEvent.subscribe(
            this,
            function(args){applyBindings(window.JVZoo.Common.AsjQueryObject(args.targetElement));},
            {}
        )
    });
})(window, jQuery);